import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import { Remittanceinfo } from '../../onboarding/classes/remittanceinfo';

@Injectable()
export class RemittanceInfoService {

  constructor(private http: Http) { }

  getRemittanceInfo(orgId: number) {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.get(`${environment.organizationsUrl}${orgId}/${environment.rpAccountsUrl}`, options)
      .map(res => res.json())
  }

  addRemittanceInfo(orgId: number, info: Remittanceinfo) {
    let data = { rp_account: info, commit: 'Add', organization_id: orgId };
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.post(`${environment.organizationsUrl}${orgId}/${environment.rpAccountsUrl}`, data, options)
      .map(res => res.json())
  }

  editRemittanceInfo(orgId: number, id: number, info: Remittanceinfo) {
    let data = { rp_account: info, commit: 'Add', organization_id: orgId };
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.patch(`${environment.organizationsUrl}${orgId}/organization_setups/rp_accounts/${id}.json`, data, options)
      .map(res => res.json())
  }

  deleteRemittanceInfo(orgId: number, id: number) {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.delete(`${environment.organizationsUrl}${orgId}/organization_setups/rp_accounts/${id}.json`, options)
      .map(res => res.json())
  }


}



// WEBPACK FOOTER //
// ./src/app/onboarding/services/remittance-info.service.ts